<template>
  <form @submit.prevent="submitHandler">
    <b-card class="mb-3">
      <error-messages
        v-if="errorMessages.length > 0"
        :show="true"
        :messages="errorMessages"
      />
      <b-card>
        <template #header>
          <h4 class="m-0">
            تغییر منابع دیتابیس
          </h4>
        </template>
        <main-text>
          از این قسمت می توانید منابع خود را تغییر دهید.(در این قسمت نمی توانید
          فضای خود را تغییر دهید.)
        </main-text>
        <resource :storageDisabled="true" :createNew="false" />
      </b-card>
    </b-card>
    <loading-btn
      type="submit"
      variant="primary"
      :loading="loading"
      :disabled="loading"
    >
      ثبت تغییرات
    </loading-btn>
  </form>
</template>

<script>
import { mapState } from "vuex";
import Resource from "@/components/Resource/Resource.vue";
import MainText from "@/components/MainText/MainText.vue";
import { userServiceChangeResource } from "@/services/resource";
import LoadingBtn from "@/components/LoadingBtn/LoadingBtn.vue";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";
import { sleep } from "../../../utils/functions";

export default {
  components: { Resource, MainText, LoadingBtn, ErrorMessages },
  name: "AppResize",
  data() {
    return {
      loading: false,
      errorMessages: []
    };
  },
  computed: {
    ...mapState("resource", ["cpu", "ram"])
  },
  methods: {
    submitHandler: async function() {
      this.loading = true;
      const [error, data] = await userServiceChangeResource({
        serviceId: this.$route.params.serviceId,
        cpu: this.cpu.value,
        ram: this.ram.value
      });
      if (error) {
        this.loading = false;
        this.errorMessages = error;
      } else {
        if (data.apiStatus === 200) {
          sleep(6000);
          this.loading = false;
        } else {
          this.loading = false;
          this.errorMessages = data.apiErrors;
        }
      }
    }
  }
};
</script>
